import { useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { usePrivacyPolicyControl } from '~/hooks/usePrivacyPolicy';
import { PrivacyPolicyDialog } from '~/pages/Portal/Admin/PrivacyPolicy/PrivacyPolicyDialog';
import { setPrivacyPolicyRead } from '~/services/PrivacyPolicy';

export const PrivacyPolicyControl: React.VFC = () => {
  const { data, isLoading, refetch, isPreviousData } =
    usePrivacyPolicyControl();
  const { isOpen, onOpen, onClose } = useDisclosure();
  useEffect(() => {
    if (!!data && !isPreviousData) {
      onOpen();
    }
  }, [data]);

  const setarStatusLido = (id: number) => {
    setPrivacyPolicyRead(id).then(() => {
      refetch();
      onClose();
    });
  };

  if (!data || !data?.id) {
    return null;
  }

  return (
    <PrivacyPolicyDialog
      politica={data}
      onCloseModal={onClose}
      isOpenModal={isOpen}
      setarStatusLido={setarStatusLido}
    />
  );
};
